import React from 'react';
import { BoxProps, Flex, Icon, Text } from '@qga/roo-ui/components';
import styled from '@emotion/styled';

interface PointsPerDollarProps extends BoxProps {
  justifyContent?: string;
  pointsPerDollar: number;
  fontSize: string[] | string;
  strikeThroughDefaultPoints?: boolean;
  color?: string;
  luxuryInclusions?: boolean;
  isMobile?: boolean;
  topMargin?: number;
}

const PointsBox = styled(Flex)`
  justify-content: start;
  line-height: tight;
`;

const PointsPerDollar = ({ pointsPerDollar, color = 'greys.charcoal', luxuryInclusions = false, topMargin = 1 }: PointsPerDollarProps) => {
  return (
    <>
      <PointsBox mt={topMargin}>
        {luxuryInclusions && <Icon name="roo" mr="4px" mt="3px" color="brand.primary" size={20} />}
        <Text color={color} fontSize={'16px'} mr={1}>
          Earn
        </Text>
        <Text data-testid="points-per-dollar" color={color} fontSize={'16px'} fontWeight="bold" mr={1}>
          {pointsPerDollar} PTS
        </Text>
        <Text color={color} fontSize={'16px'}>
          {' '}
          per $1 spent^
        </Text>
      </PointsBox>
    </>
  );
};

export default PointsPerDollar;
